import React, { useState, useEffect } from "react";
import { SignOut } from "@phosphor-icons/react";
import "../../styles/layout/Navbar.css";
import { useMamdani } from "../../context/MamdaniContext";

export default function Navbar({ username = "Shani", active = "monitor", onLogout, onPageChange, connected, onToggleSidebar }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const { mamdaniMode: mm } = useMamdani();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.ab-user-wrapper')) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <nav className="ab-navbar">

      {/* LEFT – User + Sidebar Toggle */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        
        {/* כפתור Sidebar */}
        <button
          onClick={onToggleSidebar}
          style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px' }}
        >
          <img src="/image/sidebar.png" alt="menu" style={{ width: 28, height: 28 }} />
        </button>

        {/* User */}
        <div className="ab-user-wrapper">
          <div className="ab-user" onClick={() => setShowDropdown(!showDropdown)}>
            <img src="/image/navbar/account.png" alt="user" style={{ width: 32, height: 32 }} />
          </div>

          {showDropdown && (
            <div className="ab-user-dropdown">
              <button className="ab-dropdown-item" onClick={onLogout}>
                <SignOut size={18} weight="duotone" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>

        {/* Mamdani */}
        <button
          className={`mamdani-nav-btn ${active === 'mamdani' ? 'mamdani-nav-btn--active' : ''}`}
          onClick={() => onPageChange && onPageChange('mamdani')}
        >
          <span className="mamdani-nav-dot" />
          Mamdani
        </button>
      </div>

      {/* CENTER – Navigation */}
      <div className="ab-nav-links">
        {!mm && (
          <button className={`ab-nav-item ${active === "monitor" ? "is-active monitor" : ""}`} onClick={() => onPageChange && onPageChange("monitor")}>
            <span>Real-time Monitor</span>
            <img src="/image/navbar/RealTime.png" alt="monitor" style={{ width: 18, height: 18 }} />
          </button>
        )}

        <button className={`ab-nav-item ${active === "cyber" ? "is-active cyber" : ""}`} onClick={() => onPageChange && onPageChange("cyber")}>
          <span>Cyber Room</span>
          <img src="/image/navbar/cyber.png" alt="cyber" style={{ width: 18, height: 18 }} />
        </button>

        <button className={`ab-nav-item ${active === "dark" ? "is-active" : ""}`} onClick={() => onPageChange && onPageChange("dark")}>
          <span>Threat Map</span>
          <img src="/image/navbar/darknetwork.png" alt="dark" style={{ width: 18, height: 18 }} />
        </button>

        <button className={`ab-nav-item ${active === "speech" ? "is-active" : ""}`} onClick={() => onPageChange && onPageChange("speech")}>
          <span>Speech Analysis</span>
          <img src="/image/navbar/Speech.png" alt="speech" style={{ width: 18, height: 18 }} />
        </button>

        {!mm && (
          <button className={`ab-nav-item ${active === "vpn" ? "is-active" : ""}`} onClick={() => onPageChange && onPageChange("vpn")}>
            <span>VPN</span>
            <img src="/image/navbar/VPN.png" alt="vpn" style={{ width: 18, height: 18 }} />
          </button>
        )}

        <button className={`ab-nav-item ${active === "ai" ? "is-active" : ""}`} onClick={() => onPageChange && onPageChange("ai")}>
          <span>AI Assistant</span>
          <img src="/image/navbar/Ai.png" alt="ai" style={{ width: 18, height: 18 }} />
        </button>
      </div>
      {/* RIGHT – Logo */}
      <div className="ab-brand" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative' }}>
        <img
          src={`${process.env.PUBLIC_URL}/image/logo.png`}
          alt="ANTIBOT"
          className="ab-brand-logo"
        />
      </div>

    </nav>
  );
}